angular.module("modalModificaRichPrev.components", [])
  .component("modalModificaRichPrev", {
    templateUrl: "ng/components/modalModificaRichiestaPreventivo/modalModificaRichiestaPreventivo.view.html",
    bindings: {
      updateList: '&'
    },
    controllerAs: "modificaRichiestaPreventivoCtrl",
    controller: modalModificaRichiestaPreventivoController
  });

function modalModificaRichiestaPreventivoController(
  $modalService,
  $rootScope,
  $transactionFactory,
  $simulationService

) {

  var self = this;

  self.$onInit = function () {
    self.model = {
      nota: "",
      deletePrevPreventive: {
        selected: false
      }
    }
    self.supportModel = {
      infoPratica: $transactionFactory.get(),
      restCalled: false
    }
    $transactionFactory.clear();



  }

  self.closeModal = function (id) {

    $modalService.closeModal(id);
    $rootScope.showmodalModificaPreventivo = false;
  }

  self.check = function (el) {
    el.selected = !el.selected;
  }

  self.confermModal = function () {
    self.supportModel.restCalled = true;
    $simulationService.variazioneRichiestaPrev(self.supportModel.infoPratica.id, self.model.nota, self.model.deletePrevPreventive.selected)
      .then(function (response) {
        if (response.success) {
          self.closeModal('modal-modificaRichiestaPreventivo')
          $rootScope.showmodalModificaPreventivo = false;
          self.updateList();
        }
        self.supportModel.restCalled = false;
      })
      .catch(function (error) {
        self.supportModel.restCalled = false;
      })
  }

}